import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center px-4">
        {/* Icono y número 404 */}
        <div className="mb-8">
          <div className="inline-flex h-24 w-24 items-center justify-center rounded-soft bg-primary/10 mb-4">
            <Search className="h-12 w-12 text-primary" />
          </div>
          <h1 className="text-8xl font-heading font-bold text-foreground mb-2">
            404
          </h1>
        </div>

        {/* Mensaje */}
        <h2 className="text-3xl font-heading font-semibold text-foreground mb-4">
          Página no encontrada
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>

        {/* Botones de acción */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-soft bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-smooth"
          >
            <Home className="h-4 w-4" />
            Volver al inicio
          </Link>
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 rounded-soft border border-border bg-background px-6 py-3 text-sm font-medium text-foreground hover:bg-muted transition-smooth"
          >
            Ir al Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;